const trackAdwordsEvent = (event, config) => {
  if (window.gtag && typeof window.gtag === 'function') {
    window.gtag('event', event, config);
  }
};

export default trackAdwordsEvent;
